import React from 'react';
import { SHAPES } from './Shapes';

const Shape = ({ shapeType, rotation, onDragStartCell, onPointerDownCell }) => {
  const shapeConfiguration = SHAPES[shapeType][rotation];

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 50px)', // assume max 4x4 piece grid
    gridTemplateRows: 'repeat(4, 50px)'
  };

  return (
    <div className="shape-grid" style={gridStyle}>
      {Array.from({ length: 16 }).map((_, index) => {
        const row = Math.floor(index / 4);
        const col = index % 4;
        const isFilled = shapeConfiguration.some(([dx, dy]) => dx === row && dy === col);
        return (
          <div
            key={index}
            className={`shape-cell ${isFilled ? 'filled' : ''}`}
            style={{
              width: '50px',
              height: '50px',
              backgroundColor: isFilled ? '#4CAF50' : 'transparent',
              border: '1px solid #ccc',
              touchAction: 'none',   // help prevent scroll on touch
              userSelect: 'none',
              cursor: isFilled ? 'grab' : 'default'
            }}
            draggable={isFilled} // desktop HTML5 DnD only from filled (green) cells
            onDragStart={isFilled ? (e) => onDragStartCell && onDragStartCell(e, row, col) : undefined}
            onPointerDown={isFilled ? (e) => onPointerDownCell && onPointerDownCell(e, row, col) : undefined}
          />
        );
      })}
    </div>
  );
};

export default Shape;
